import ApiClient from "../apiClient";

export interface InstrumentWeekPerformanceRow {
  date: string;
  pointPerformance: number | null;
  percentPerformance: number | null;
  vixPercentPerformance: number | null;
  source: string;
  isStored: boolean;
}

export interface InstrumentWeekPerformanceResponse {
  contract: string;
  weekStart: string;
  weekEnd: string;
  rows: InstrumentWeekPerformanceRow[];
  fetchedAt: string;
}

export interface TradeWeekPerformanceRow {
  date: string;
  pnl: number;
  erScore: number | null;
  winRate: number | null;
  sessionDurationSeconds: number;
  tradeCount: number;
}

export interface TradeWeekPerformanceResponse {
  weekStart: string;
  weekEnd: string;
  rows: TradeWeekPerformanceRow[];
  source: "internal-user-ledger";
  fetchedAt: string;
}

export interface PerformanceWeekService {
  getInstrumentWeekPerformance(input: {
    contract: string;
    anchor?: string;
  }): Promise<InstrumentWeekPerformanceResponse>;
  getTradeActivityWeek(input?: {
    anchor?: string;
  }): Promise<TradeWeekPerformanceResponse>;
}

export function createPerformanceWeekService(
  client: ApiClient,
): PerformanceWeekService {
  return {
    getInstrumentWeekPerformance(input) {
      const query = new URLSearchParams({ contract: input.contract });
      if (input.anchor) query.set("anchor", input.anchor);
      return client.get<InstrumentWeekPerformanceResponse>(
        `/api/market-data/performance-week?${query.toString()}`,
      );
    },
    getTradeActivityWeek(input) {
      const query = new URLSearchParams();
      if (input?.anchor) query.set("anchor", input.anchor);
      const suffix = query.toString() ? `?${query.toString()}` : "";
      return client.get<TradeWeekPerformanceResponse>(
        `/api/data/performance-week${suffix}`,
      );
    },
  };
}
